enum ActivityPlanning {
    Unknown,
    Planned,
    Unplanned
}

export { ActivityPlanning };
